import JourneyDetails from './JourneyDetails';

export default JourneyDetails;
